import { makeStyles, Typography } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'

import { useActionRunner, useNotification } from 'src/modules/notification'
import { Container, PageTitle, Button } from '../../../../../ui'

import { useRecipes } from '../../hooks'
import IngredientForm from '../forms/IngredientForm'
import { ChevronLeft as ChevronLeftIcon } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  body: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    [theme.breakpoints.up('desktop')]: {
      flexDirection: 'row',
    },
  },
  content: {
    flexGrow: 1,
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  buttonLink: {
    textDecoration: 'none',
  },
  backLink: {
    textDecoration: 'inherit',
  },
  backButton: {
    textDecoration: 'none',
    marginBottom: theme.spacing(1),
    color: theme.palette.lightGreen.main,
    textTransform: 'none',
  },
}))

const EditIngredientFormView = () => {
  const { id } = useParams()
  const history = useHistory()
  const classes = useStyles()

  const { showError } = useNotification()

  const {
    fetchIngredientById,
    ingredient,
    updateIngredient,
    fromRecipeId,
    resetFromRecipeId,
  } = useRecipes()
  const [doUpdateIngredient] = useActionRunner(updateIngredient)

  const [fetchData] = useActionRunner([() => fetchIngredientById(id)], {
    initialFetchingState: true,
  })

  useEffect(() => {
    fetchData()
  }, [])

  const onSubmit = async values => {
    const body = {
      name: values.name,
      unit: values.unit,
      agreement_products: values.products.map(p => p.id),
      external_product:
        values.externalProductName && values.externalProductPrice
          ? {
              name: values.externalProductName,
              price: values.externalProductPrice,
            }
          : {},
    }
    const result = await doUpdateIngredient({ id, body })
    try {
      unwrapResult(result)
      history.push(`/recipes/ingredients`)
    } catch (error) {
      console.log(error)
      let errorMessage = `You have some errors in your form: \n\n ${
        error.data !== undefined ? error.data['name'] : ''
      }`

      showError(errorMessage)
    }
  }

  return (
    <Container>
      {fromRecipeId ? (
        <Link
          className={classes.backLink}
          onClick={() => resetFromRecipeId()}
          to={`/recipes/detail/${fromRecipeId}`}
        >
          <Button
            className={classes.backButton}
            size="large"
            startIcon={<ChevronLeftIcon />}
            variant="text"
          >
            Back to Recipe
          </Button>
        </Link>
      ) : null}
      <PageTitle>Ingredient</PageTitle>
      <div className={classes.body}>
        <div className={classes.content}>
          {ingredient ? (
            <IngredientForm
              onSubmit={onSubmit}
              title="Add Ingredient"
              editData={ingredient}
            />
          ) : (
            <Typography>Loading...</Typography>
          )}
        </div>
      </div>
      <></>
    </Container>
  )
}

export default EditIngredientFormView
